/**
 * Cornice: sidebar desktop + barra mobile.
 * Collega navigazione alle schermate esistenti (re-skin + cornice).
 */

/**
 * Click su voci shell → schermate / azioni account.
 */
export function setupAppShell() {
  const shell = document.querySelector("[data-testid='app-shell']");
  if (!shell || shell.dataset.shellBound === "1") return;
  shell.dataset.shellBound = "1";

  shell.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-shell-nav]");
    if (!btn) return;
    const nav = btn.getAttribute("data-shell-nav");
    this.handleAppShellNav?.(nav);
  });

  this.syncAppShellNav?.();
}

/**
 * @param {string} nav
 */
export function handleAppShellNav(nav) {
  switch (nav) {
    case "lista":
      this.setAuctionMode?.("prep");
      this.switchAuctionScreen?.("lista");
      break;
    case "live":
      this.setAuctionMode?.("live");
      this.switchAuctionScreen?.("lista");
      break;
    case "studio":
      this.switchAuctionScreen?.("studio");
      break;
    case "rosa":
      this.switchAuctionScreen?.("rosa");
      break;
    case "rose-altri":
      this.switchAuctionScreen?.("rose-altri");
      break;
    case "analytics":
      this.switchAuctionScreen?.("analytics");
      break;
    case "settings":
      this.openAuctionSettings?.();
      break;
    case "setup":
      this.showUnifiedSetupScreen?.();
      break;
    default:
      break;
  }
}

/**
 * Evidenzia la voce attiva in sidebar e bottom nav.
 */
export function syncAppShellNav() {
  const lista = document.getElementById("screen-lista");
  const studio = document.getElementById("screen-studio");
  const rosa = document.getElementById("screen-rosa");
  const roseAltri = document.getElementById("screen-rose-altri");
  const analytics = document.getElementById("screen-analytics");

  let key = "lista";
  if (studio && !studio.hidden) key = "studio";
  else if (rosa && !rosa.hidden) key = "rosa";
  else if (roseAltri && !roseAltri.hidden) key = "rose-altri";
  else if (analytics && !analytics.hidden) key = "analytics";
  else if (lista && !lista.hidden) {
    key = this.state?.auctionMode === "live" ? "live" : "lista";
  }

  const sidebarKeys = new Set(["lista", "live", "studio", "rosa", "rose-altri", "analytics"]);
  document.querySelectorAll(".app-sidebar [data-shell-nav]").forEach((btn) => {
    const nav = btn.getAttribute("data-shell-nav");
    if (!sidebarKeys.has(nav)) return;
    btn.classList.toggle("is-active", nav === key);
  });

  // Mobile: Durante asta non ha tab dedicata → Svincolati attivo anche in live
  const bottomKey = key === "live" ? "lista" : key;
  document.querySelectorAll(".app-bottom-nav [data-shell-nav]").forEach((btn) => {
    const nav = btn.getAttribute("data-shell-nav");
    btn.classList.toggle("is-active", nav === bottomKey);
  });
}

/**
 * Aggiorna badge conteggi Studio/Rosa nella sidebar (oltre agli id legacy).
 */
export function syncAppShellCounts() {
  const studioEl = document.getElementById("studio-count");
  const rosaEl = document.getElementById("rosa-count");
  const studioN = studioEl?.textContent ?? "0";
  const rosaN = rosaEl?.textContent ?? "0";
  document.querySelectorAll('[data-shell-count="studio"]').forEach((el) => {
    el.textContent = studioN;
  });
  document.querySelectorAll('[data-shell-count="rosa"]').forEach((el) => {
    el.textContent = rosaN;
  });
  this.renderListaKpiStrip?.();
}
